//Font Awesome
import '../bundle/font-awesome/scss/fontawesome.scss'
import '../bundle/font-awesome/scss/solid.scss'
import '../bundle/font-awesome/scss/brands.scss'
import '../bundle/font-awesome/scss/light.scss'
import '../bundle/font-awesome/scss/regular.scss'
import '../bundle/font-awesome/scss/duotone.scss'

//Front UI (Index UI)
import '../bundle/front-ui/vendor/slick-carousel/slick/slick.css'
import '../bundle/scss/aos.scss'
import '../bundle/front-ui/vendor/hs-mega-menu/src/scss/hs-mega-menu.scss'
import '../bundle/front-ui/scss/theme.scss'

//Bootstrap UI
import '../bundle/scss/_variables.scss'
import '../bundle/scss/bootstrap-addons.scss'
import '../bundle/scss/styles-global-UI.scss'

//DYL Specific UI
import '../bundle/scss/landing-pages.scss'
import '../bundle/scss/industries.scss'
import '../bundle/scss/advantages.scss'
import '../bundle/scss/product.scss'
import '../bundle/scss/area-codes.scss'



//Stream UI
import '../bundle/css/stream-styles.css'

//Media Query Bootstrap
import '../bundle/scss/sm-breakpoints.scss'
import '../bundle/scss/md-breakpoints.scss'
import '../bundle/scss/lg-breakpoints.scss'
import '../bundle/scss/xl-breakpoints.scss'

///////////////Javascript//////////////////
///////////////////////////////////////////

//jQuery, Bootstrap, Popper
import 'jquery'
import '../bundle/js/jquery-migrate'
import 'bootstrap'

//Component Vendors
import '../bundle/vendors/jquery.parallax'

//Global Theme Setting and Calls
import '../bundle/js/stream/global'

//Global Theme Setting and Calls
import '../bundle/js/pre-loader'
import '../bundle/js/front-init'
